import { AdminAppEvents } from "../app-admin/events";
import { IAdminAuthRequest } from "../entities-generated/models/admin-auth/admin-auth-request";
import { EventNotificationService } from "../framework/services/event-notification";
import { isNotNullOrWhitespace } from "../framework/utils";
import { AdminAuthApiClient } from "./admin-auth-client";

class AdminSignInServiceClass {
  public isAuthenticated() {
    return this.secretKey != null;
  }

  public getAdminSecret() {
    return this.secretKey ?? '';
  }

  public signIn(endpoint: string, request: IAdminAuthRequest) {
    if(this.isAuthenticated()) {
      return Promise.resolve({ success: true });
    }

    return AdminAuthApiClient.adminAuth(endpoint, request)
      .then(resp => {
        if(isNotNullOrWhitespace(resp.secret)) {
          this.secretKey = resp.secret;
          return { success: true };
        } 

        return { success: false };
      })
      .catch(err => {
        if(err === 404) { // bad endpoint provided
          return Promise.resolve({ success: false });
        }
        return Promise.reject(err);
      });
  }

  public signOut() {
    this.secretKey = null;
    EventNotificationService.dispatch(AdminAppEvents.ForceSignIn);
  }

  private secretKey: string | null = null;
}

export const AdminSignInService = new AdminSignInServiceClass();